<template>
  <div class="pr-2 pl-1 py-1 d-flex node" :class="{ 'no-lines': !hasChildren }">
    <collapse-caret
      class="mx-1 mt-1 flex-shrink-0"
      :class="{
        invisible: !hasChildren || hideCaret
      }"
      :size="16"
      :container-to-icon-ratio="0.5"
      :expanded="expanded"
      @click="expanded = !expanded"
      v-if="!hideCaret"
    />
    <div class="node-content flex-grow-1" ref="node">
      <div
        class="text-medium-1 d-flex align-items-center justify-content-between"
        :class="{
          selected: isSelected
        }"
      >
        <div class="d-flex align-items-center">
          <i
            class="flex-shrink-0"
            :class="{
              'org-icon': !team.parentId,
              'child-org-icon mr-1': team.parentId && team.isOrgLike
            }"
          ></i>
          <span
            class="text-truncate pointer team-name"
            :class="{ 'ml-2': !team.isOrgLike }"
            @click="switchToOrg()"
            v-no-capture
            >{{ team.name }}</span
          >
        </div>
        <i class="checkmark-icon ml-2" v-if="isSelected"></i>
      </div>
      <b-collapse v-model="expanded" v-if="team.children.length > 0">
        <div class="child-node text-small-1 pt-2">
          <team-item
            v-for="childTeam in team.children"
            :key="childTeam.id"
            :team="childTeam"
            :selected-org-id="selectedOrgId"
            :selected-sub-org-id="selectedSubOrgId"
            :expanded-on-launch="expandedOnLaunch"
            :navigate-through-transition="navigateThroughTransition"
            :hide-caret="hideCaret"
            :next-route-name="nextRouteName"
            :next-route-query="nextRouteQuery"
            @select="$emit('select')"
          ></team-item>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import CollapseCaret from '@/components/CollapseCaret'
import { goalsTabIds } from '@/constants/goals'
import { ROUTE_NAMES } from '@/constants/routes'
import { getTeamPageRouteConfig } from '@/utils/navigationConfigs'
import startViewTransition from '@/utils/startViewTransition'
import { BCollapse } from 'bootstrap-vue'

/**
 * This shows orgLike teams as tree view. Since this gives a tree view, user can expand/collapse parent team to view/hide child teams.
 */
export default {
  name: 'TeamItem',
  props: [
    'team',
    'selectedOrgId',
    'selectedSubOrgId',
    'expandedOnLaunch',
    'hideCaret',
    'navigateThroughTransition',
    'nextRouteName',
    'nextRouteQuery'
  ],
  components: {
    BCollapse,
    CollapseCaret
  },
  data() {
    return {
      expanded: this.expandedOnLaunch
    }
  },
  computed: {
    rootTeamId() {
      const org = this.$store.getters.orgById(this.team.organizationId)
      return org.rootTeamId
    },
    hasChildren() {
      return this.team.children && this.team.children.length > 0
    },
    hasSubOrgId() {
      const test = team => {
        if (team.id === this.selectedSubOrgId) {
          return true
        } else {
          return team.children && team.children.some(test)
        }
      }
      return this.team.organizationId === this.selectedOrgId && test(this.team)
    },
    isSelected() {
      return (
        this.team.organizationId === this.selectedOrgId && this.team.id === this.selectedSubOrgId
      )
    }
  },
  methods: {
    switchToOrg(subOrgId) {
      if (!subOrgId) {
        subOrgId = this.team.id
      }
      /**
       * @emits
       * This is emitted when an org/suborg is selected
       */
      this.$emit('select')
      startViewTransition(() => {
        const isOrgLike = this.team.isOrgLike
        let location
        if (isOrgLike) {
          const routeName = this.nextRouteName || ROUTE_NAMES.TEAM
          const params = { orgId: this.team.organizationId, subOrgId }
          if (routeName === ROUTE_NAMES.TEAM) {
            params.teamId = subOrgId
          }
          location = {
            name: routeName,
            params,
            query: {
              ...this.nextRouteQuery,
              teamId: this.team.id
            }
          }
        } else {
          location = getTeamPageRouteConfig({
            orgId: this.team.organizationId,
            teamId: this.team.id,
            entity: goalsTabIds.goals
          })
        }
        this.$router.push(location)
      }, !this.navigateThroughTransition)
    }
  },
  mounted() {
    this.expanded = this.expandedOnLaunch || this.hasSubOrgId
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/styleGuide.scss';

@include treeNodeConnector(15px, -8px, 6px, -12px, 17px);

.caret {
  margin-top: 3px;
}

.selected {
  @extend .bold;
}

.checkmark-icon {
}
.node .node {
  margin-left: 0px;
}
.org-icon {
  margin-right: 5px;
}
.no-lines {
  background: none;
}
.node .child-node {
  margin-left: 8px;
}
.team-name:hover {
  font-weight: 600;
}
</style>
